
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pitch-your-story",
      function () {
        return require("private-next-pages/pitch-your-story/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pitch-your-story"])
      });
    }
  